export async function sectionNav(options) {
    let { SectionNav } = await import(/* webpackMode: "lazy" */ './section-nav/section-nav.js');

    return new SectionNav(options);
}
